<template>
  <div id="app">
    <div
      class="pointer-mask"
      v-if="disablePoint || pageDisableEvent"
      :data-point="disablePoint"
    ></div>
    <transition :name="'vux-pop-' + direction">
      <keep-alive>
        <router-view
          class="router-view"
          :class="'router-' + direction"
          v-if="$route.meta.keepAlive"
        ></router-view>
      </keep-alive>
    </transition>
    <transition :name="'vux-pop-' + direction">
      <router-view
        class="router-view"
        :class="'router-' + direction"
        v-if="!$route.meta.keepAlive"
      ></router-view>
    </transition>
    <iframe-modal
      :w="$store.state.postmateIframe.iframeWidth"
      :h="$store.state.postmateIframe.iframeHeight"
    />
    <!-- 声音预留 -->
    <!-- <div :class="['sound-handler', { open: status, close: !status }]">
      <div
        :class="['ef-sound', { off: !efSound }]"
        @click="changeEfSound"
      ></div>
      <div
        :class="['bg-sound', 'disable', { off: !publicBGM }]"
        @click="changeBgSound"
      ></div>
      <div class="toggle" @click="status = !status"></div>
    </div> -->
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import IframeModal from "@/components/common/IframeModal";

export default {
  name: "App",
  data() {
    return {
      status: false, // 是否展开
      disablePoint: false, // 页面按钮是否可点击
    };
  },
  watch: {
    "$route.path": {
      async handler() {
        this.disablePoint = true;
        this.$eventHub.$once("pageAniEnd", () => {
          this.disablePoint = false;
        });
      },
      immediate: true,
    },
  },
  components: {
    IframeModal,
  },
  computed: {
    ...mapState("userInfo", {
      isFirst: (state) => {
        return !!state.info.first_join;
      }, // 是否第一次进入
    }),
    ...mapState({
      direction: "direction",
      publicBGM: "publicBGM",
      efSound: "efSound",
      pageDisableEvent: "pageDisableEvent",
    }),
    ...mapGetters("petInfo", {
      petInfo: "firstPetInfo", // 宠物信息
    }),
  },
  methods: {
    changeEfSound() {
      this.$store.dispatch("upDateEfSound", !this.efSound);
    },
    changeBgSound() {
      this.$store.dispatch("upDateBGM", !this.publicBGM);
    },
  },
};
</script>


<style lang="scss">
body {
  @include bgImg("root/loading_bg.jpg");
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;

  &.loaded {
    @include bgImg("root/default_bg.jpg");
  }
}
#app {
  // perspective: 1200px;
}
.pointer-mask {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 9997;
}
.sound-handler {
  @include bgImg("root/sound-handler_bg.png");
  position: absolute;
  top: 0;
  bottom: 0;
  left: -0.74rem;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  width: 0.74rem;
  height: 1.75rem;
  margin: auto;
  transition: left 0.3s ease-in-out;

  .toggle {
    @include bgImg("root/sound-handler_open.png");
    position: absolute;
    right: -0.265rem;
    top: 0;
    bottom: 0;
    width: 0.28rem;
    height: 0.87rem;
    margin: auto;
  }

  .ef-sound {
    @extend .icon-efsound_on;

    &.off {
      @extend .icon-efsound_off;
    }
  }

  .bg-sound {
    @extend .icon-sound_on;

    &.off {
      @extend .icon-sound_off;
    }
  }

  &.open {
    left: 0;

    .toggle {
      @include bgImg("root/sound-handler_close.png");
    }
  }

  .disable {
    pointer-events: none;
  }
}
// .iframe-container {
//   position: fixed;
//   top: 0;
//   bottom: 0;
//   right: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   z-index: 10000;
//   opacity: 0;
//   transition: opacity 0.3s;
//   &.alpha {
//     opacity: 1;
//   }
//   .out-page {
//     width: 100%;
//     height: 100%;
//     margin: 0;
//     padding: 0;
//     border: none;
//   }
// }
</style>
